import React, { useState } from "react";
import { SetupPageTemplate } from "../components/registration-setup-pages/SetupPageTemplate";
import { Introduction } from "../components/registration-setup-pages/Introduction";
import { InitialData } from "../components/registration-setup-pages/InitialData";
import { Consent } from "../components/registration-setup-pages/Consent";
import { Password } from "../components/registration-setup-pages/Password";
import { PersonalDetails } from "../components/registration-setup-pages/PersonalDetails";
import { Summary } from "../components/registration-setup-pages/Summary";
import { ReadyToStart } from "../components/registration-setup-pages/ReadyToStart";

function RegistrationSetup(props) {
	const [page, setPage] = useState(1);
	const [data, setData] = useState({});

	const handleClickNext = () => {
		loadNextPage();
	};

	const handleClickBack = () => {
		loadPrevPage();
	};

	const loadNextPage = () => {
		setPage(page + 1);
	};

	const loadPrevPage = () => {
		setPage(Math.max(page - 1, 1));
	};

	const onDataComplete = (context, datum) => {
		const _data = { ...data };
		_data[context] = datum;

		setData(_data);

		loadNextPage();
	};

	const loadStartRoute = () => {
		props.history.push("/");
	};

	if (page === 1) {
		return (
			<SetupPageTemplate
				onClickNext={handleClickNext}
				onClickBack={loadStartRoute}
			>
				<Introduction />
			</SetupPageTemplate>
		);
	} else if (page === 2) {
		return (
			<SetupPageTemplate
				onClickNext={data.initialData ? handleClickNext : null}
				onClickBack={handleClickBack}
			>
				<InitialData
					context="initialData"
					data={data.initialData}
					onDataComplete={onDataComplete}
				/>
			</SetupPageTemplate>
		);
	} else if (page === 3) {
		return (
			<SetupPageTemplate
				onClickNext={data.password ? handleClickNext : null}
				onClickBack={handleClickBack}
			>
				<Password
					context="password"
					data={data.password}
					onDataComplete={onDataComplete}
				/>
			</SetupPageTemplate>
		);
	} else if (page === 4) {
		return (
			<SetupPageTemplate
				onClickNext={data.pid ? handleClickNext : null}
				onClickBack={handleClickBack}
			>
				<PersonalDetails
					context="pid"
					data={data.pid}
					onDataComplete={onDataComplete}
				/>
			</SetupPageTemplate>
		);
	} else if (page === 5) {
		return (
			<SetupPageTemplate
				onClickNext={data.consent ? handleClickNext : null}
				onClickBack={handleClickBack}
			>
				<Consent
					context="consent"
					data={data.consent}
					pid={data.pid}
					onDataComplete={onDataComplete}
					diseaseGroup={data.pid.diseaseGroup}
				/>
			</SetupPageTemplate>
		);
	} else if (page === 6) {
		return (
			<SetupPageTemplate onClickNext={null} onClickBack={handleClickBack}>
				<Summary data={data} onDataComplete={handleClickNext} />
			</SetupPageTemplate>
		);
	} else if (page === 7) {
		return (
			<SetupPageTemplate onClickNext={loadStartRoute} onClickBack={null}>
				<ReadyToStart />
			</SetupPageTemplate>
		);
	}
}

export default RegistrationSetup;
